module.exports = __webpack_public_path__ + "img/bricks-bg.c7b9bfc4.jpg";